export default {
  DESKTOP_XL: 1440,
  DESKTOP: 1280,
  TABLET_XL: 1024,
  TABLET: 768,
  PHONE: 360,
};
